import React from "react";
import Header from "../../header/Header";
import Hero from "./Hero";
import Footer from "../../footer/Footer";

const It = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Footer />
    </div>
  );
};

export default It;
